import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './DeleteProductModal.scss';

const DeleteProductModal = (props) => {
  const { form, isOpen, closeModal, reason, onSubmit, setData } = props;

  return (
    <Modal
      title="상품 삭제"
      isOpen={isOpen}
      width={560}
      height={200}
      isFooter={true}
      okText="상품 삭제"
      overflow="hidden"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <InfoForm className="delete-product-modal">
        <TextAreaForm
          form={form}
          label="상품 삭제 사유"
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          initialValue={reason}
          onChange={(value) => setData({ name: 'reason', value })}
          name="reason"
          rows={6}
        />
      </InfoForm>
    </Modal>
  );
};

export default DeleteProductModal;
